import React, { useRef, useState } from 'react';
import { Box, IconButton, Slider, Typography } from '@mui/material';
import { PlayArrow, Pause } from '@mui/icons-material';

export const AudioMessage = ({ url }) => {
    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);

    const togglePlay = () => {
        const audio = audioRef.current;
        if (!audio) return;

        if (audio.paused) {
            audio.play();
            setIsPlaying(true);
        } else {
            audio.pause();
            setIsPlaying(false);
        }
    };

    const handleTimeUpdate = () => {
        const audio = audioRef.current;
        if (audio) setCurrentTime(audio.currentTime);
    };

    const handleLoadedMetadata = () => {
        const audio = audioRef.current;
        if (audio) setDuration(audio.duration);
    };

    const handleSliderChange = (_, value) => {
        const audio = audioRef.current;
        if (audio) {
            audio.currentTime = value;
            setCurrentTime(value);
        }
    };

    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#1c2a34',
            borderRadius: '10px',
            width: '100%',
            maxWidth:'100%',
            gap: 1,
        }}>
            <audio
                ref={audioRef}
                src={url}
                onTimeUpdate={handleTimeUpdate}
                onLoadedMetadata={handleLoadedMetadata}
                onEnded={() => setIsPlaying(false)}
                style={{ display: 'none' }}
            />
            <IconButton onClick={togglePlay} size="small" sx={{ color: '#fff' }}>
                {isPlaying ? <Pause /> : <PlayArrow />}
            </IconButton>
            <Slider
                size="small"
                value={currentTime}
                min={0}
                max={duration}
                onChange={handleSliderChange}
                sx={{
                    color: '#25d366',
                    flexGrow: 1,
                    mx: 1
                }}
            />
            <Typography sx={{ fontSize: '10px', color: '#ccc', minWidth: '35px' }}>
                {formatTime(currentTime)}
            </Typography>
        </Box>
    );
};

const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60)
        .toString()
        .padStart(2, '0');
    return `${minutes}:${seconds}`;
};
